import { render, staticRenderFns } from "./DsfrCurrencyField.vue?vue&type=template&id=7cf758f0&"
import script from "./DsfrCurrencyField.vue?vue&type=script&lang=js&"
export * from "./DsfrCurrencyField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports